import { Box } from "@material-ui/core";
import { MpTable } from "@mp-react/table";
import { useParams } from "react-router-dom";
import React, { useCallback, useMemo } from "react";
import { useBenefitInnerTermsAcceptanceType } from "../../../../../configs/Tables/BenefitsTermsAcceptance";
import { rowMethods } from "../../../../../utils/TableMethods";
import useTableUtils from "../../../../../utils/Table";
import {
  useBenefitTermsAcceptance,
  useBenefitTermsAcceptanceAsyncMethods,
} from "../../../../../state/BenefitsTermsAcceptance";
import { useHistory } from "react-router";
import { Row, UseRowSelectRowProps } from "react-table";
import { useTermsAcceptanceNotifications } from "../../../../../utils/TermsAcceptanceNotifications";
import SendReminderDialog from "../../../../../components/dialogs/SendReminderDialog/SendReminderDialog";
import { ReminderRequest } from "../../../../../types/NotificationService";

export default function TermsAcceptance() {
  const {
    overridables,
    overrideClasses,
    translations,
    handleGetData,
    loadingComponent,
    noDataComponent,
    tableQueryParam,
  } = useTableUtils("innerBenefitTermsAcceptance");
  const TermsAcceptanceTableType = useBenefitInnerTermsAcceptanceType();
  const { id } = useParams() as any;
  const {
    parsedBenefitTermsAcceptanceList,
    benefitTermsAcceptance,
    loading,
    parsedBenefitTermsAcceptanceTotals,
    bulkMethods,
  } = useBenefitTermsAcceptance(id, tableQueryParam);

  const asyncGetMethods = useBenefitTermsAcceptanceAsyncMethods(id);
  const history = useHistory();
  const {
    sendReminder,
    successEmployeeId,
    handleCloseDialog,
    openDialog,
    sendReminderAgain,
    getIdsForRequest,
    loadingNotifications,
  } = useTermsAcceptanceNotifications(undefined, id, "benefit");

  const reminderDialogEmployees = useMemo(
    () => successEmployeeId ?? [],
    [successEmployeeId]
  );

  const bulkMethodsWithReminder = useMemo(
    () => ({ ...bulkMethods, sendReminder }),
    [bulkMethods, sendReminder]
  );

  const handleRowClick = useCallback(
    (current: (Row<{}> & UseRowSelectRowProps<{}>) | undefined) => {
      const { original } = current as any;
      history.push(
        `/employees/view/${original.employeeId}?tab=innerEmployeeTermsAcceptance`
      );
    },
    [history]
  );

  const handleSubmit = useCallback(async () => {
    const employeeAndBenefitIds: ReminderRequest[] =
      getIdsForRequest(successEmployeeId);
    const result = await sendReminderAgain(employeeAndBenefitIds);
    if (result) handleCloseDialog();
  }, [
    getIdsForRequest,
    handleCloseDialog,
    sendReminderAgain,
    successEmployeeId,
  ]);

  return (
    <Box>
      <MpTable
        {...TermsAcceptanceTableType}
        data={parsedBenefitTermsAcceptanceList}
        onGetData={handleGetData}
        bulkMethods={bulkMethodsWithReminder}
        overridables={overridables}
        totalsData={parsedBenefitTermsAcceptanceTotals}
        totals={parsedBenefitTermsAcceptanceList?.length > 0}
        stickyTotals={true}
        disablePagination={true}
        classes={overrideClasses}
        pageSize={benefitTermsAcceptance?.pageSize ?? 20}
        loading={loading}
        enableGlobalActions={true}
        rowMethods={rowMethods}
        translations={translations}
        loadingComponent={loadingComponent}
        emptyChildren={noDataComponent}
        asyncGetMethods={asyncGetMethods}
        onRowClick={handleRowClick}
      />
      <SendReminderDialog
        open={openDialog}
        slug={"sendReminder"}
        onCancelClick={handleCloseDialog}
        onSubmit={handleSubmit}
        id="send-reminder-dialog"
        responseData={reminderDialogEmployees}
        showNames="employee"
        loading={loadingNotifications}
      />
    </Box>
  );
}
